import { ConstantsService } from '../../../services/constants.service';
import { environment } from '../../../../environments/environment';
import { HttpClient} from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { Injectable } from '@angular/core';

const base_url = environment.base_url;

@Injectable({
  providedIn: 'root'
})
export class ElementoNivelPermisoService {
  public url = ConstantsService.ELEMENTOS_NIVEL_PERMISO_URL;
  constructor(private http:HttpClient) { }

  create(formData:any):Observable<any> {
      return this.http.post(`${this.url}`, formData).pipe(map(data => {return data;}
        ));
    }

  list(query: string = ''): Observable<any> {
     return this.http.get(`${this.url}${query}`).pipe(map(
        data => {return data;}
      ));;

  }
  update(formData:any): Observable<any>{
    let {idSprElementoNivelPermiso} = formData;
    return this.http.patch(`${this.url}${idSprElementoNivelPermiso}`,formData).pipe(map(
      data => {
        return data;
      }
    ));
  }

  delete(dataDelete:any): Observable<any>{
    return this.http.patch(`${this.url}${dataDelete.idSprElementoNivelPermiso}`,dataDelete ) }
  }